class LocalStorageAlternative {
  constructor() {
    this.structureLocalStorage = {};
  }

  setItem(key, value) {
    this.structureLocalStorage[key] = value;
  }

  getItem(key) {
    if (typeof this.structureLocalStorage[key] !== 'undefined') {
      return this.structureLocalStorage[key];
    }
    return null;
  }

  removeItem(key) {
    this.structureLocalStorage[key] = undefined;
  }
}

let storage;

function initLocalStorageAlternative() {
  console.warn('No local storage support. Return alternative.');
  storage = new LocalStorageAlternative();
  return storage;
}

export function getLocalStorage() {
  // Check cache first.
  if (storage) {
    return storage;
  }
  try {
    // Check if the browser supports local storage.
    if (!localStorage) {
      return initLocalStorageAlternative();
    }
  } catch (_e) {
    return initLocalStorageAlternative();
  }

  try {
    // If there is local storage but browser is in private mode,
    // the next lines will fail.
    localStorage.setItem('__TEST__', '');
    localStorage.removeItem('__TEST__');
    storage = localStorage;
  } catch (_err) {
    storage = initLocalStorageAlternative();
  }
  return storage;
}

export function setSortModel(columnDefs, sortModel) {
  if (sortModel.length === 0) {
    return columnDefs;
  }
  return columnDefs.map((column) => ({
    ...column,
    sort: column.field === sortModel[0].colId ? sortModel[0].sort : undefined,
  }));
}

export const removeNullCharacter = (str) => {
  if (!str) {
    return '';
  }
  return str.replace(/\0/g, '');
};
